export default {
  glow: {
    active: 'Actif',
    blankText: '(vierge)',
    cancel: 'Annuler',
    clearAll: 'Tout effacer',
    close: 'Fermer',
    copied: 'Copié',
    confirm: 'Confirmer',
    copyValue: 'Copier {{value}}',
    copyFailed: 'Échec de la copie',
    deselectAll: 'Tout déselectionner',
    dismiss: 'Rejeter',
    event: {
      serviceUpgrade: {
        title: 'Mise à niveau du service',
        curbside: 'Curbside',
        indoor: 'Indorr',
        deliveryDate: 'La date de livraison'
      },
      shorterTimeWindow: {
        title: 'Fenêtre de temps plus courte'
      }
    },
    emptyStates: {
      notFoundTitle: 'Aucun résultat trouvé !',
      notFoundDescription:
        'Nous n’avons trouvé aucun résultat. Veuillez essayer de modifier votre filtre de recherche.',
      initialTitle: '’Pas d’informations pour l’instant',
      successTitle: 'Bravo! Bien joué!'
    },
    filter: 'Filtre',
    filterOverlay: {
      filter: 'Filtrer',
      activeFilterCount: '{{count}} filtre actif',
      activeFilterCount_other: '{{count}} filtres actifs',
      clearFilter: 'Effacer le filtre'
    },
    from: 'De',
    goToPage: 'Aller à la page',
    group: 'Groupe',
    invalidDateFormat: 'Format de date invalide',
    openCalendar: 'Ouvrir le calendrier',
    loading: 'Chargement en cours',
    no: 'Non',
    none: 'Aucun choix',
    notActivated: 'Non activé',
    of: 'de',
    orderOfTable: 'Ordre des en-têtes de tableau',
    orderOfTableDescription: 'Choisissez l’ordre préféré des en-têtes de tableau en glissant-déplaçant.',
    fixedTableHeadersDescription:
      'Les en-têtes de tableau suivants sont fixes et ne peuvent pas être supprimés ou réorganisés.',
    page: 'Page',
    selectAll: 'Tout sélectionner',
    selectAllCount: 'Tout sélectionner ({{count}})',
    selectAllOnPage: 'Tout sélectionner sur la page ({{count}})',
    search: 'Rechercher',
    settings: 'Paramètres',
    to: 'À',
    yes: 'Oui',
    accordionMessage: {
      error: "{{count}} messages d'erreur",
      warning: "{{count}} messages d'avertissement",
      info: "{{count}} messages d'information",
      general: '{{count}} messages'
    },
    invalidRegistrationNumber:
      "Merci de saisir un numéro d'immatriculation valide ne contenant que des lettres et des chiffres"
  }
}
